/**
 * Map Center Updater Component for Leaflet
 * Extracted from App.js - Phase 7B Frontend Refactor
 */
import { useEffect } from "react";
import { useMap } from "react-leaflet";

const MapCenterUpdater = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView([center.lat, center.lng], map.getZoom());
    }
  }, [center, map]);
  return null;
};

export default MapCenterUpdater;
